export default {
      id: "getcall-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "icons-sprite.102705a.svg#getcall-usage",
      toString: function () {
        return this.url;
      }
    }